if (!customElements.get('variant-options-toggle')) {
  class VariantOptionsToggle extends HTMLElement {
    connectedCallback() {
      this.grid = this.closest('.variant-options-grid');
      this.button = this.querySelector('button');
      if (!this.grid || !this.button) return;

      this.moreLabel = this.querySelector('[data-more]');
      this.lessLabel = this.querySelector('[data-less]');

      const overflowChecked = Array.from(this.grid.querySelectorAll('input[type=radio]:checked')).some(
        (input) => input.nextElementSibling?.classList.contains('variant-pill--overflow')
      );
      if (overflowChecked) this.setExpanded(true);

      this.button.addEventListener('click', () => this.setExpanded(!this.expanded));
    }

    get expanded() {
      return this.grid.classList.contains('is-expanded');
    }

    setExpanded(value) {
      this.grid.classList.toggle('is-expanded', value);
      this.button.setAttribute('aria-expanded', value ? 'true' : 'false');
      if (this.moreLabel) this.moreLabel.hidden = value;
      if (this.lessLabel) this.lessLabel.hidden = !value;
    }
  }

  customElements.define('variant-options-toggle', VariantOptionsToggle);
}
